import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import {getReport, getMDAYearly} from '../../../actions/index'
import Load from '../../../components/Load'
import _ from 'lodash'
import moment from 'moment-timezone'
import {timezone} from '../../../constants'
import {downloadLink} from '../../../constants'

const AnnualReportsView = ({loading, dispatch, report, MDAYearly}) => {

    const exportCSV = () => {
        if (!((MDAYearly || {}).data || {}).data) {return}
        downloadLink(((MDAYearly || {}).data || {}).data || '', 'export.tsv')
    }

    return <div style={{marginTop: '50px'}}>
        <Grid fluid>
            <Row>
                <Col xs={12} md={6} className="groups-header">ANNUAL AND QUARTERLY REPORTS</Col>
                <Col xs={12} md={6} />
            </Row>

            {loading.getReport && <Row><Load/></Row>}

            {!loading.getReport && report && <Row>
                {report.error ? <div>{report.error}</div> :
                <a href={report.report}>{`Open: ${report.year} ${report.quarter ? `Q${report.quarter}` : `annual` } report pdf`}</a>}
            </Row>}

            {_.range(2016, moment().tz(timezone).year() + 1).map(y => <Row key={y}>
                <Col xs={6}>
                    <button className="inline-block link no-underline" onClick={() => dispatch(getReport(y, null))}>{`${y} annual`}</button>
                </Col>
                <Col xs={6}>
                    {_.range(1, y < moment().tz(timezone).year() ? 5 : Math.ceil(moment().tz(timezone).month() / 3)).map(q => <div key={`${y}q${q}`}>
                        <button className="inline-block link no-underline" onClick={() => dispatch(getReport(y, q))}>{`${y} Q${q}`}</button>
                    </div>)}
                </Col>
            </Row>)}

            <Row style={{marginTop: '100px'}}>
                <Col xs={12} md={6} className="groups-header">ACOUSTIC CONSULTANT FUNCTIONS</Col>
                <Col xs={12} md={6} />
            </Row>

            {loading.getMDAYearly && <Row><Load/></Row>}

            {_.range(2016, moment().tz(timezone).year() + 1).map(y => <Row key={`y${y}`}>
                <Col xs={6}>
                    <button className="inline-block link no-underline" onClick={() => dispatch(getMDAYearly(y))}>{`${y} noise export`}</button>
                </Col>
            </Row>)}

            {!loading.getMDAYearly && MDAYearly && <Row>
                {MDAYearly.error ? <div>{MDAYearly.error}</div> :
                    <div><button className="inline-block link no-underline" onClick={exportCSV}>{`Export as CSV (${MDAYearly.year})`}</button></div>}
            </Row>}

        </Grid>

    </div>
}

export default AnnualReportsView





// WEBPACK FOOTER //
// ./src/components/admin/report/AnnualReportsView.jsx